import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Paper,
  Grid,
  Chip,
  IconButton,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  WarningAmberRounded,
  Phone,
  Email,
  UpgradeRounded,
  ContactSupportRounded,
} from "@mui/icons-material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import AccountUsageDetails from "./AccountUsageDetails";

const AccountExpiredCard = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const adminContacts = [
    {
      name: "Support Manager",
      phone: "+91 (787) 199-2677",
      email: "info@smartgrowthai.com",
    },
    {
      name: "Account Administrator",
      phone: "+91 (080) 6199-9966",
      email: "support@smartgrowthai.com",
    },
  ];

  const handleContact = (type, value) => {
    if (type === "phone") {
      window.open(`tel:${value}`);
    } else if (type === "email") {
      window.open(`mailto:${value}`);
    }
  };

  const handleUpgrade = () => {
    // Handle upgrade logic here
    navigate(`/pricing-plans`);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        p: 2,
      }}
    >
      <Card
        sx={{
          position: "relative",
          maxWidth: "md",
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
          overflow: "hidden",
        }}
      >
        <Box sx={{ position: "absolute", top: 8, right: 16 }}>
          <Button
            sx={{ color: "white", border: "1px solid white" }}
            startIcon={<LogoutIcon />}
            variant="outlined"
            onClick={() => {
              navigate(`/logout`);
            }}
          >
            Logout
          </Button>
        </Box>
        <Box
          sx={{
            background: "linear-gradient(45deg, #ff6b6b 0%, #ee5a24 100%)",
            color: "white",
            p: 3,
            textAlign: "center",
          }}
        >
          <WarningAmberRounded sx={{ fontSize: 60, mb: 2 }} />
          <Typography
            variant="h4"
            component="h1"
            fontWeight="bold"
            gutterBottom
          >
            Account Expired
          </Typography>
          <Typography variant="h6" sx={{ opacity: 0.9 }}>
            Your subscription has ended
          </Typography>
        </Box>
        <AccountUsageDetails self={true} />
        <CardContent sx={{ px: 4 }}>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ textAlign: "center", mb: 4, fontSize: "1.1rem" }}
          >
            Please contact our administration team or upgrade your account to
            continue using our services.
          </Typography>

          {/* Contact Information */}
          <Paper
            elevation={2}
            sx={{
              p: 3,
              mb: 4,
              borderRadius: 2,
              background: theme.palette.background.default,
            }}
          >
            <Typography
              variant="h6"
              gutterBottom
              sx={{ display: "flex", alignItems: "center", mb: 3 }}
            >
              <ContactSupportRounded sx={{ mr: 1, color: "primary.main" }} />
              Contact Administration
            </Typography>

            <Grid container spacing={3}>
              {adminContacts.map((contact, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Box
                    sx={{
                      p: 2,
                      border: `1px solid ${theme.palette.divider}`,
                      borderRadius: 2,
                      textAlign: "center",
                      height: "100%",
                    }}
                  >
                    <Chip
                      label={contact.name}
                      color="primary"
                      variant="outlined"
                      sx={{ mb: 2 }}
                    />

                    <Box
                      sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                    >
                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<Phone />}
                        onClick={() => handleContact("phone", contact.phone)}
                        fullWidth
                        sx={{ justifyContent: "flex-start" }}
                      >
                        {contact.phone}
                      </Button>

                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<Email />}
                        onClick={() => handleContact("email", contact.email)}
                        fullWidth
                        sx={{ justifyContent: "flex-start" }}
                      >
                        {contact.email}
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Paper>

          {/* Action Buttons */}
          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: 2,
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              size="large"
              startIcon={<UpgradeRounded />}
              onClick={handleUpgrade}
              sx={{
                flex: isMobile ? 1 : "none",
                py: 1.5,
                px: 4,
                background: "linear-gradient(45deg, #10ac84 0%, #1dd1a1 100%)",
                "&:hover": {
                  background:
                    "linear-gradient(45deg, #0f9b78 0%, #18ba92 100%)",
                },
              }}
            >
              Upgrade Now
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AccountExpiredCard;
